import React from 'react';
import { useNavigate } from 'react-router-dom';
import './styles/header.css';

export interface HeaderProps {
  title?: string;
  showBack?: boolean;
  rightAction?: React.ReactNode;
}

export const Header: React.FC<HeaderProps> = ({
  title,
  showBack = false,
  rightAction,
}) => {
  const navigate = useNavigate();

  return (
    <header className="header">
      <div className="header__content">
        {showBack && (
          <button
            onClick={() => navigate(-1)}
            className="header__back"
            aria-label="Go back"
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path
                d="M15 18L9 12L15 6"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        )}
        
        {title && <h1 className="header__title">{title}</h1>}
        
        <div className="header__logo">
          <span className="logo-zero">Zero</span>
          <span className="logo-moblt">Moblt</span>
        </div>
        
        {rightAction && <div className="header__action">{rightAction}</div>}
      </div>
    </header>
  );
};